export default __webpack_public_path__ + "static/Marlin Elza Pranata-66a0d7cbcccde3137989bc09badf2c6b.webp";